import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import View from '../../../../../components/pdf/View'
import { Bullets, Paragraph, SectionHeading } from './_shared/Prose'

/**
 * Seção 16 do arquivo - combina duas seções curtas do modelo aprovado por Julia Buzzo:
 * Seção 15 "Registro e Controle das Informações" e Seção 16 "Avaliação Contínua e
 * Revisão do PGR". Substitui o placeholder institucional anterior (arquivo era
 * `16.ComunicacaoRiscoSection.js` — o conteúdo de comunicação de risco do modelo real
 * está na subseção 9.5, ver `09.ClassificacaoRiscosFisicoQuimicoBiologicoSection.js`).
 * As seções 15 e 16 foram combinadas neste único arquivo/slot pelo mesmo motivo que
 * antes explicava outros agrupamentos análogos deste documento (arquivos "11"/"12"
 * ocupados por conteúdo duplicado que foi corrigido nesta revisão, ver `PdfDocument.js`
 * para o mapa completo): os arquivos com prefixo "15" e "16" já continham conteúdo real
 * e confirmado (Gestão Participativa/CIPA e Gestão de Empresas Terceiras), então as
 * seções curtas do bloco institucional foram agrupadas no único slot de placeholder
 * ainda disponível. Fora do escopo desta revisão — Julia reportou apenas as Seções
 * 10-12, não 15/16.
 */
const RegistroControleAvaliacaoRevisaoSection = () => (
  <View id="15">
    <Separator weight={15} />
    <SectionHeading numero={15}>REGISTRO E CONTROLE DAS INFORMAÇÕES</SectionHeading>

    <Paragraph>
      Todos os dados obtidos durante as etapas do PGR — desde o reconhecimento até a avaliação e controle dos
      riscos — serão documentados, registrados e mantidos conforme legislação vigente. A rastreabilidade dos
      registros será assegurada por meio de documentação datada e assinada, com histórico de revisões devidamente
      arquivado por, no mínimo, 20 anos.
    </Paragraph>

    <Separator weight={10} />

    {/* `id="16"` num wrapper próprio (não dá para passar `id` ao `SectionHeading` — ele não
        aceita/repassa essa prop, ver `_shared/Prose.js`) — é a âncora real da Seção 16 para
        o Sumário (link + página); antes apontava para `#15`, o único id disponível no
        arquivo (ver histórico em `00b.SumarioSection.js`). NÃO usar `display: contents`
        aqui: neste Chromium (o mesmo motor usado por `page.pdf()`/impressão) um elemento
        `display: contents` devolve um `getBoundingClientRect()` zerado (0,0,0,0) — medido
        e confirmado durante o desenvolvimento deste PR — o que quebraria o cálculo de
        página real do Sumário (ver `_helpers/pagination.js`) só para este item. Um `<div>`
        de bloco comum aqui não muda o layout visual (`SectionHeading` já só renderiza
        filhos de bloco). */}
    <div id="16">
      <SectionHeading numero={16}>AVALIAÇÃO CONTÍNUA E REVISÃO DO PGR</SectionHeading>
    </div>

    <Paragraph>O Programa de Gerenciamento de Riscos será revisto periodicamente ou sempre que houver:</Paragraph>
    <Bullets
      items={[
        '1. Implantação de novas medidas de prevenção;',
        '2. Mudanças em processos, tecnologia, ambiente ou organização do trabalho;',
        '3. Identificação de falhas nos controles existentes;',
        '4. Ocorrência de acidentes, incidentes ou doenças ocupacionais;',
        '5. Alterações legais que impactem os requisitos aplicáveis.'
      ]}
    />

    <Paragraph>
      A periodicidade padrão da revisão é bienal, podendo ser trienal em empresas do grupo que estão certificadas em
      sistemas de gestão de SST.
    </Paragraph>

    <Paragraph>A avaliação da efetividade do PGR considerará:</Paragraph>
    <Bullets
      items={[
        'Indicadores de saúde ocupacional;',
        'Cumprimento das metas do plano de ação;',
        'Aplicação prática das medidas de controle propostas.'
      ]}
    />

    <Separator weight={15} />
  </View>
)

export default RegistroControleAvaliacaoRevisaoSection
